export const REMOVE_WORK_EXPERIENCE_PENDING = "REMOVE_WORK_EXPERIENCE_PENDING";
export const REMOVE_WORK_EXPERIENCE_SUCCESS = "REMOVE_WORK_EXPERIENCE_SUCCESS";
export const REMOVE_WORK_EXPERIENCE_ERROR = "REMOVE_WORK_EXPERIENCE_ERROR";

/** REMOVE **/
export const removeWorkExperiencePending = () => {
  return { type: REMOVE_WORK_EXPERIENCE_PENDING };
};

export const removeWorkExperienceSuccess = (payload) => {
  return { type: REMOVE_WORK_EXPERIENCE_SUCCESS, payload };
};

export const removeWorkExperienceError = (message) => {
  return { type: REMOVE_WORK_EXPERIENCE_ERROR, message };
};
